import React, { useRef } from 'react';

import { ModuleDispatcher } from '$partials/modules';
import { Header } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').GenericPage}
 */
const GenericPage = (props) => {
    const page = props.data.page;
    const bodyRef = useRef();
    return (
        <>
            <Header
                {...props.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}/>
            <main
                className='bg-white relative z-10'
                id='main-content'
                ref={bodyRef}>
                <div className='px-layout-outer pb-16 mt-[50px]'>
                    <div className='-mx-layout-col flex flex-wrap'>
                        <div className='px-layout-col w-full sm:w-2/7'>
                            <h1>
                                {page.title}
                            </h1>
                        </div>
                        <div className='hidden sm:flex px-layout-col w-1/7'/>
                        <div className='px-layout-col w-full sm:w-2/7 pt-24 sm:pt-0'>
                            {page?.modules?.length > 0 && (
                                <section className='bg-[white] z-10 relative'>
                                    {page.modules.map((module, i) => (
                                        <ModuleDispatcher
                                            {...module}
                                            key={i + module?.id}/>
                                    ))}
                                </section>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default GenericPage;
